export default __webpack_public_path__ + "static/media/PVLC-1.5dcd2341.jpg";